import script from "./ForumList.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumList.vue?vue&type=script&setup=true&lang=js"

import "./ForumList.vue?vue&type=style&index=0&id=51b6de50&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51b6de50"]])

export default __exports__